import { Component, OnInit, Injectable, PLATFORM_ID, Inject, OnChanges } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from "../../services/product.service";
import { Product } from "../../classes/product";
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  public products: Product[] = [];
  public search: boolean = false;
  public toggled: boolean = false;
  
  public languages = [{ 
    name: 'English',
    code: 'en'
  }, {
    name: 'French',
    code: 'fr'
  }];

  public currencies = [{
    name: 'Euro',
    currency: 'EUR',
    price: 0.90 // price of euro
  }, {
    name: 'Rupees',
    currency: 'INR',
    price: 70.93 // price of inr
  }, {
    name: 'Pound',
    currency: 'GBP',
    price: 0.78 // price of euro
  }, {
    name: 'Dollar',
    currency: 'USD',
    price: 1 // price of usd
  }]

  public isOrderPage: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private translate: TranslateService,
    public productService: ProductService) {
      this.productService.cartItems.subscribe(response => {this.products = response}, (error) => {
        this.products = [];
      });  }

  ngOnInit(): void {
    if (this.router.url.includes('/shop/collection/left/sidebar'))
    {
      this.isOrderPage = true;
    }

    this.router.events.subscribe(event => {

      if (event instanceof NavigationEnd)
      {
        this.productService.cartItems.subscribe(response => {this.products = response}, (error) => {
          this.products = [];
        });

        if (event.url.includes('/shop/collection/left/sidebar'))
        {
          this.isOrderPage = true;
        }
        else {
          this.isOrderPage = false;
        }
      }
    });
  }

  // searchToggle(){
  //   this.search = !this.search;
  // }



  changeLanguage(code){
    if (isPlatformBrowser(this.platformId)) {
      this.translate.use(code)
    }
  }

  get getTotal(): Observable<number> {
    return this.productService.cartSubtotalAmount();
  }

  removeItem(product: any) {
    this.productService.removeCartItem(product);
  }

  changeCurrency(currency: any) {
    this.productService.Currency = currency
  }

  closeBasket()
  {
    var element = document.getElementById("testtest");

    element.classList.toggle("show-div-visible");
    this.toggled = true;

    // console.log(element);
  }

  showBasket()
  {
    var element = document.getElementById("testtest");

    if (this.toggled)
    {
      element.classList.toggle("show-div-visible");
      this.toggled = false;
    }

    // console.log(element);
  }

}
